import React, { memo } from 'react'

import useCategories from 'utils/hooks/queries/games/useCategories'

import { GamesCategoryGrid } from '../../components/GamesCategoryGrid'
import withHide from '../../components/withHide'
import SmartCategoryWithData from '../SmartCategory/SmartCategoryWithData'
import TournamentCategories from '../TournamentCategories/TournamentCategoriesWithData'

function CategoriesGrid() {
  const { data: categories, isPending } = useCategories()

  if (isPending || !categories) {
    return null
  }

  return (
    <>
      <SmartCategoryWithData />
      <TournamentCategories />
      {categories
        .filter(({ slug }) => slug !== 'all')
        .map(({ id, label, slug, games, rows }) => (
          <GamesCategoryGrid
            key={id}
            categoryLabel={label}
            slug={slug}
            games={games}
            rows={rows}
          />
        ))}
    </>
  )
}

export default withHide(memo(CategoriesGrid))
